module.exports = __webpack_public_path__ + "static/sample-37a9939d57ed2aff98e3b87561a2a00f.png";